export default __webpack_public_path__ + "static/media/logo.249f3d2b.jpeg";